export const FETCH = 'artful-client/FeatureFlags/FETCH';
export const FETCH_SUCCESS = 'artful-client/FeatureFlags/FETCH_SUCCESS';
export const FETCH_FAILURE = 'artful-client/FeatureFlags/FETCH_FAILURE';

export const FLAG_LIST_RECOVERY = 'LIST_RECOVERY';
export const FLAG_DRAWINGS = 'DRAWINGS';
export const FLAG_LIST_FOLDERS = 'LIST_FOLDERS';
export const FLAG_HABITS_TAB = 'HABITS_TAB';
export const FLAG_ZENDESK_BOT = 'ZENDESK_BOT';
export const FLAG_APP_SPECIFIC_PASSWORD = 'APP_SPECIFIC_PASSWORD';
